import {useEffect,} from 'react';

import {useBillingProviders} from '../hooks/useBillingProviders.ts';
import {FieldProps} from 'formik';
import {FormikGenericCombobox} from '@flexinet/ui-components';
import {BillingProvider} from "../types.ts";
import {TextInputProps} from "@mantine/core";

export const BillingProvidersAutocomplete = (props: FieldProps & TextInputProps) => {


    const {
        items: records,
        loading,
        fetchRecords
    } = useBillingProviders();


    useEffect(() => {
        fetchRecords();
    }, [fetchRecords]);


    return (
        <FormikGenericCombobox
            records={records || []}
            valueFieldName={'id'}
            renderOption={(record: BillingProvider) => (record.name)}
            getSelectedOption={(record: BillingProvider) => record.name}
            isLoading={loading}
            {...props}
        />
    );

};